import { queryString } from './URLUtils';
import { isAllowedTrigger } from './OdigeoInteractions';

export const CookieUtils = {
    readCookies: () => {
        return queryString(document.cookie, ';'); // eslint-disable-line no-restricted-properties
    },

    readCookie: (name) => {
        return isAllowedTrigger('cookies', name) ? CookieUtils.readCookies()[name]: null;
    },
};
